import React, { useContext, useRef, useEffect, useState } from "react";
import ArrowDown from "../../Assets/Images/Arrowdown.svg";
import "./product.css";
import ProductBanner from "../../Components/Product/ProductBanner";
import BenefitSectionPlanPage from "../../Components/BenefitsSectionPlanPage";
import PricingSectionHome from "../../Components/PricingSectionHome/PricingSectionHome";
import HealthServices from "../../Components/HealthServices";
import CapsuleSlider from "../../Components/CapsuleSlider";
import WellnessHero from "../../Components/WellnessHero";
import BenefitsSection from "../../Components/BenefitdSection";
import UpgradeNetwork from "../../Components/UpgradeNetwork";
import FAQs from "../../Components/FAQs";
import HealthInsuranceHero from "../../Components/HealthInsuranceHero";
import HomeOverlayElement1 from "../../Assets/Images/home-overlay-element-1.png";
import HomeOverlayElement2 from "../../Assets/Images/home-overlay-element-3.png";
import HomeOverlayElement3 from "../../Assets/Images/home-overlay-element-2.png";
import CoverImage from "../../Assets/Images/benefits-section-product-3.png";
import SliderSection from "../../Components/SliderSection";
import NavBar from "../../Components/NavBar";
import desktopImage from "../../Assets/Images/product-banner-3.png";
import mobileImage from "../../Assets/Images/product-banner-3-mobile.png";

import BenefitRiderIcon1 from "../../Assets/Images/benefit-rider-blue-icon1.svg";
import BenefitRiderIcon2 from "../../Assets/Images/benefit-rider-icon2.svg";
import BenefitRiderIcon3 from "../../Assets/Images/benefit-rider-icon3.svg";
import BenefitRiderIcon4 from "../../Assets/Images/benefit-rider-blue-icon4.svg";
import BenefitRiderIcon5 from "../../Assets/Images/benefit-rider-icon5.svg";

import BenefitsImage from "../../Assets/Images/account-value-img.png";
import BenefitsIcon1 from "../../Assets/Images/premiums-icon.svg";
import BenefitsIcon2 from "../../Assets/Images/interest-icon.svg";
import BenefitsIcon3 from "../../Assets/Images/deduction-icon.svg";
import BenefitsIcon4 from "../../Assets/Images/other-deduction-icon.svg";
import BenefitsRightArrowIcon from "../../Assets/Images/right-arrow.svg";
import BenefitsleftArrowIcon from "../../Assets/Images/left-arrow.svg";
import AccountValueIcon from "../../Assets/Images/account-value-icon.svg";
import BenefitsMobileImage from "../../Assets/Images/account-value-mobile-img.png";

import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";
import ProtectionPlusPolicyTab from "../../Components/ProtectionPlusPolicyTab/ProtectionPlusPolicyTab";
import ProtectionPlusPolicyTabDesktop from "../../Components/ProtectionPlusPolicyTab/ProtectionPlusPolicyTabDesktop";

import PolicyBenefitIcon1 from "../../Assets/Images/policy-benefit-icon1.svg";
import PolicyBenefitIcon2 from "../../Assets/Images/policy-benefit-icon2.svg";
import PolicyBenefitIcon3 from "../../Assets/Images/policy-benefit-icon_updated_3.svg";

import UniversalType1 from "../../Assets/Images/universal-type1.svg";
import UniversalType2 from "../../Assets/Images/universal-type2.svg";

import HomeOverlayMobileElement3 from "../../Assets/Images/universe-overlay-element-mobile-1.png";
import HomeOverlayMobileElement2 from "../../Assets/Images/universe-overlay-element-mobile-2.png";

import { Link } from "react-router-dom";

import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

import { LanguageContext } from "../../Hooks/langugaeContext";
import { TransEn, TransEs } from "../../constants/HomeBannerConst";
import { motion } from "framer-motion";

const UniversalLifeInsurance = () => {
  const translations = useTranslation(); // Get translations dynamically
  const { language } = useContext(LanguageContext);
  useAnimateOnScroll();

  const universalProductRef = useRef(null);

  const scrollToRef = useRef(null);
  const [isActive, setIsActive] = useState(false);

  const scrollToContent = () => {
    scrollToRef.current.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (window.innerWidth <= 1040) {
      setIsActive(false);
    } else {
      setIsActive(true);
    }
  }, []);

  const listItems = [
    {
      y: "30%",
      rotate: 3,
      bgColor: "bg-[#F7F6F2]",
      icon: BenefitRiderIcon1,
      heading: translations.universalBenefits.benefitsOptions.options1_title,
      content: translations.universalBenefits.benefitsOptions.options1_Desc,
    },
    {
      y: "40%",
      rotate: 4,
      bgColor: "bg-[#D8ECED] lg:bg-[#FFF4D8]",
      icon: BenefitRiderIcon2,
      heading: translations.universalBenefits.benefitsOptions.options2_title,
      content: translations.universalBenefits.benefitsOptions.options2_Desc,
    },
    {
      y: "50%",
      rotate: 5,
      bgColor: "bg-[#F7F6F2] lg:bg-[#D8ECED]",
      icon: BenefitRiderIcon3,
      heading: translations.universalBenefits.benefitsOptions.options3_title,
      content: translations.universalBenefits.benefitsOptions.options3_Desc,
    },
    {
      y: "60%",
      rotate: 6,
      bgColor: "bg-[#FFF4D8] lg:bg-[#F7F6F2]",
      icon: BenefitRiderIcon4,
      heading: translations.universalBenefits.benefitsOptions.options4_title,
      content: translations.universalBenefits.benefitsOptions.options4_Desc,
    },
    {
      y: "70%",
      rotate: 7,
      bgColor: "bg-[#D8ECED] lg:bg-[#FFF4D8]",
      icon: BenefitRiderIcon5,
      heading: translations.universalBenefits.benefitsOptions.options5_title,
      content: translations.universalBenefits.benefitsOptions.options5_Desc,
    },
  ];

  console.log("translations", translations, "language", language);

  return (
    <div className="main-container">
      <NavBar />

      <section className="home-welcome panel1 LifeUniversed-banner container-fluid">
        <div className="LifeUniversed-overlay-bg md:hidden lg:block"></div>
        <div className="home-welcome-overlay-element">
          <div className="absolute w-full h-full z-[1] md:hidden lg:block reveal-up">
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--one hidden md:block"
              src={HomeOverlayElement2}
            />
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--one block md:hidden"
              src={HomeOverlayMobileElement3}
            />
          </div>
          <div className="absolute w-full h-full md:z-[4] z-[5] md:hidden lg:block reveal-up">
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--two hidden md:block"
              src={HomeOverlayElement3}
            />
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--two block md:hidden"
              src={HomeOverlayMobileElement2}
            />
          </div>
          <div className="absolute w-full h-full z-[6] md:hidden lg:block reveal-up">
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--three "
              src={HomeOverlayElement1}
            />
          </div>
        </div>
        <div className="absolute container z-[6] left-0 right-0 md:top-0 md:bottom-0">
          <div className="h-full flex items-center max-w-[516px] md:pl-0 px-4 universal-life-banner-caption">
            <div className="relative ">
              <h1 className="lg:hidden md:mb-0 mb-4 md:leading-[33px] text-[24px] leading-[28px] md:text-[30px] font-semibold tracking-tight reveal-up">
                {translations.universalBannerHeading}{" "}
                {translations.universalBannerDesc}
              </h1>
              <h1 className="hidden lg:block md:mb-0 mb-0 md:leading-[33px] xl:leading-[2.8rem] text-[1.25rem] leading-[1.5rem] md:text-[30px] xl:text-[2.5rem] font-semibold tracking-tight reveal-up extra-title-heading">
                {translations.universalBannerHeading}
              </h1>
              <p className="hidden lg:block mb-4 md:leading-[33px] xl:leading-[2.8rem] text-[14px] leading-[20px]  md:text-[30px] xl:text-[2.5rem] reveal-up reveal-delay-2 extra-title-heading">
                {translations.universalBannerDesc}
              </p>
              <div className="text-teal-900 px-8 py-2 pl-0 rounded-full text-lg font-semibold md:hidden block">
                <div className="flex space-x-3 text-white items-center">
                  <div
                    onClick={scrollToContent}
                    className="border-radius scrollarrow arrow-border flex items-center justify-center border-2 border-white rounded-full w-[88px] h-[50px] cursor-pointer"
                  >
                    <img
                      src={ArrowDown}
                      alt="Scroll down arrow"
                      className="animate__animated animate__bounce animate__delay-2s animate__repeat-3"
                    />
                  </div>
                  <span className="hidden lg:block text-lg font-medium scrollToSeeMore">
                    {translations.aboutUsBannerButton}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute container z-[6] left-0 right-0 bottom-16 md:block hidden">
          <div className="text-teal-900 px-8 py-2 pl-0 rounded-full text-lg font-semibold">
            <div className="flex space-x-3 text-white items-center">
              <div
                onClick={scrollToContent} // Attach scroll handler
                className="border-radius scrollarrow arrow-border flex items-center justify-center border-2 border-white rounded-full w-[88px] h-[50px] cursor-pointer"
              >
                <img
                  src={ArrowDown}
                  alt="Scroll down arrow"
                  className="animate__animated animate__bounce animate__delay-2s animate__repeat-3"
                />
              </div>
              <span className="hidden lg:block text-lg font-medium scrollToSeeMore">
                {translations.aboutUsBannerButton}
              </span>
            </div>
          </div>
        </div>
      </section>
      {isActive && (
        <section className="panel" ref={scrollToRef}>
          <ProtectionPlusPolicyTabDesktop sectionRef={scrollToRef} />
        </section>
      )}

      {!isActive && <ProtectionPlusPolicyTab sectionRef={scrollToRef} />}

      <section
        className="panel1 life-benefit-policy py-24 lg:py-40 bg-[#F7F6F2]"
        id="Benefits"
      >
        <div className="container">
          <div className="flex md:flex-row flex-col md:px-12 md:items-center justify-center">
            <div className="reveal-up max-w-[490px] universallife-baenefits-header">
              <h2 className="font-semibold md:text-[30px] md:leading-[33px] xl:text-[2.5rem] xl:leading-[2.8rem] text-[24px] leading-[28px] tracking-tight md:pr-12 pr-0 md:mb-0 mb-16 text-center md:text-left extra-title-heading ">
                {translations.main_benefits_title}
              </h2>
            </div>
            <ul className="md:pl-8 pl-4 universallife-baenefits-uline">
              <li className="flex items-center max-w-[286px] tracking-tight mb-8 text-[18px] md:text-[14px] xl:text-[18px] reveal-up reveal-delay-2">
                <img src={PolicyBenefitIcon1} alt="" className="mr-6" />{" "}
                {translations.adjustable_premiums}
              </li>
              <li className="flex items-center max-w-[286px]  tracking-tight mb-8 text-[18px] md:text-[14px] xl:text-[18px] reveal-up reveal-delay-3">
                <img src={PolicyBenefitIcon2} alt="" className="mr-6" />{" "}
                {translations.build_cash_value}
              </li>
              <li className="flex items-center max-w-[286px] tracking-tight text-[18px] md:text-[14px] xl:text-[18px] reveal-up reveal-delay-4">
                <img src={PolicyBenefitIcon3} alt="" className="mr-6" />{" "}
                {translations.adjustable_death_benefit}
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="panel1 Improve-protection py-[6.5rem]">
        <div className="conntainer-fluid lg:px-16 pl-4 pr-0">
          <div className="lg:pr-0 pl-4">
            <p className="text-sm text-gray-600 mb-1 learnmoreacc md:hidden block">
              Universal Products
            </p>
            <h2
              className="md:text-center md:text-[24px] md:leading-[28px] xl:text-[1.8rem] xl:leading-[2.8rem] text-[24px] leading-[28px] mb-10 tracking-tight  extra-title-heading"
              dangerouslySetInnerHTML={{
                __html: translations.universalBenefits.improve_protection,
              }}
            ></h2>
          </div>
          <ul className="flex lg:justify-center improve-protection-uline overflow-auto whitespace-nowrap lg:mb-[5rem] lg:pr-0 pl-3">
            {listItems.map((item, index) => (
              <motion.li
                key={index}
                initial={{
                  opacity: 0,
                  transform: `translate(0%, ${item.y}) rotate(${item.rotate}deg)`,
                }}
                whileInView={{
                  opacity: 1,
                  transform: "translate(0%, 0%) rotate(0deg)",
                }}
                transition={{
                  delay: index * 0.2,
                  duration: 0.5,
                  ease: "easeOut",
                }}
                viewport={{ once: true }}
                className="lg:px-2.5 px-1 lg:w-[270px] min-w-[208px] whitespace-normal improve-protection-grid"
              >
                <div
                  className={`${item.bgColor} rounded-full md:px-5 px-3 md:py-24 h-full pt-16 pb-10`}
                >
                  <img src={item.icon} className="mb-7 " alt="" />
                  <h3 className="md:text-[14px] xl:text-[18px] text-[14px] md:leading-[18px] xl:leading-[22px] leading:[20px] font-semibold mb-4 text-[#000000]">
                    {item.heading}
                  </h3>
                  <p
                    className="text-[14px] leading-[22px] md:text-[10.5px] md:leading-[16.5px] xl:text-[14px] xl:leading-[22px] mb-3 text-[#000000]"
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  ></p>
                </div>
              </motion.li>
            ))}
          </ul>
        </div>
      </section>

      <section
        id="how-it-works"
        className="panel indexa-pro py-12 lg:py-32 bg-[#F7F6F2]"
      >
        <div className="container">
          <div className="flex lg:flex-nowrap flex-wrap gap-8">
            <div className="lg:w-[45%] w-full  flex items-center">
              <div className="lg:pl-0 px-4">
                <p className="text-sm text-gray-600 mb-1 learnmoreacc  md:hidden block">
                  Universal Products
                </p>
                <h2 className="md:text-[30px] md:leading-[33px] xl:text-[40px] xl:leading-[44px] text-[24px] leading-[28px] tracking-tight font-semibold lg:max-w-[400px] how-indexa-title reveal-up">
                  {translations.title_how_indexa_works}
                </h2>
                <div className="lg:mt-[10rem] mt-4 lg:max-w-[470px] md:text-[12px] md:leading-[17px] xl:text-[16px] xl:leading-[22px] text-[14px]">
                  <p className="mb-4 text-justify extra-para-vs reveal-up reveal-delay-2">
                    {translations.how_indexa_worksDesc1}
                  </p>

                  <p
                    className="text-justify extra-para-vs reveal-up reveal-delay-3"
                    dangerouslySetInnerHTML={{
                      __html: translations.how_indexa_worksDesc2,
                    }}
                  ></p>
                </div>
              </div>
            </div>
            <div className="lg:w-[55%] w-full">
              <div className="flex items-center justify-center">
                <div className="max-w-[200px] flex flex-col lg:px-0 px-4 how-indexa-pro-col">
                  <div className="benefits-grid flex items-center justify-between my-20 reveal-up">
                    <div>
                      <div className="b-icon  lg:mb-4 mb-1">
                        <img src={BenefitsIcon1} alt="Benefits Icon" />
                      </div>
                      <h3 className="md:text-[12px] xl:text-[1rem] text-[12px] font-semibold mb-2 tracking-tight md:leading-[16px] xl:leading-[20px] leading-[14px] extra-para-vs">
                        {translations.premiums_title}
                      </h3>
                      <p className="md:!text-[10px] md:leading-[14px] xl:!text-[13px] xl:leading-[20px] tracking-tight hidden lg:block extra-para-vs" >
                        {translations.premiums_info}
                      </p>
                    </div>
                    <div>
                      <img
                        className="min-w-[27px] ml-4"
                        src={BenefitsleftArrowIcon}
                        alt="Benefits Icon"
                      />
                    </div>
                  </div>
                  <div className="benefits-grid flex items-center justify-between  my-20 reveal-up">
                    <div>
                      <div className="b-icon lg:mb-4 mb-1">
                        <img src={BenefitsIcon2} alt="Benefits Icon" />
                      </div>
                      <h3 className="md:text-[12px] xl:text-[1rem] text-[12px] font-semibold mb-2 tracking-tight md:leading-[16px] xl:leading-[20px] leading-[14px] extra-para-vs">
                        {translations.interest_title}
                      </h3>
                    </div>
                    <div>
                      <img
                        className="min-w-[27px] ml-4"
                        src={BenefitsleftArrowIcon}
                        alt="Benefits Icon"
                      />
                    </div>
                  </div>
                </div>
                <div className="mx-4 how-idexa-image relative animate__animated animate__zoomIn">
                  <img className="hidden lg:block" src={BenefitsImage} alt="" />
                  <img
                    className="block lg:hidden"
                    src={BenefitsMobileImage}
                    alt=""
                  />
                  <div
                    className="flex justify-center flex-col lg:min-w-[160px] xl:min-w-[215px] min-w-[150px] items-center lg:p-3 xl:p-5 p-2.5 rounded-full bg-white absolute top-[50%] lg:left-[-75px] xl:left-[-100px] left-[-100px] account-value-div"
                    style={{ boxShadow: "4px 3px 13.5px rgb(0 0 0 / 12%)" }}
                  >
                    <img
                      className="md:mb-2 mb-1 md:w-[30px] lg:w-[22px] xl:w-[30px] w-[18px]"
                      src={AccountValueIcon}
                      alt=""
                    />
                    <p className="font-semibold md:text-[14px] xl:text-[18px] text-[12px] md:leading-[18px] xl:leading-[22px] leading-[17px] tracking-tight">
                      {translations.account_value}
                    </p>
                  </div>
                </div>
                <div className="max-w-[200px] flex flex-col how-indexa-pro-col">
                  <div className="benefits-grid flex items-center justify-between lg:my-16 my-20 reveal-up">
                    <div>
                      <img
                        className="min-w-[27px] mr-4"
                        src={BenefitsRightArrowIcon}
                        alt="Benefits Icon"
                      />
                    </div>
                    <div>
                      <div className="b-icon lg:mb-4 mb-1 ">
                        <img src={BenefitsIcon3} alt="Benefits Icon" />
                      </div>
                      <h3 className="md:text-[12px] xl:text-[1rem] text-[12px] font-semibold mb-2 tracking-tight md:leading-[16px] xl:leading-[20px] leading-[14px] extra-para-vs">
                        {translations.monthly_deductions_title}
                      </h3>
                      <p className="md:!text-[10px] md:leading-[14px] xl:!text-[13px] xl:leading-[20px] tracking-tight hidden lg:block extra-para-vs">
                        {translations.monthly_deductions_info}
                      </p>
                    </div>
                  </div>
                  <div className="benefits-grid flex items-center justify-between lg:my-16 my-20 reveal-up">
                    <div>
                      <img
                        className="min-w-[27px] mr-4"
                        src={BenefitsRightArrowIcon}
                        alt="Benefits Icon"
                      />
                    </div>
                    <div>
                      <div className="b-icon lg:mb-4 mb-1 ">
                        <img src={BenefitsIcon4} alt="Benefits Icon" />
                      </div>
                      <h3 className="md:text-[12px] xl:text-[1rem] text-[12px] font-semibold mb-2 tracking-tight md:leading-[16px] xl:leading-[20px] leading-[14px] extra-para-vs">
                        {translations.other_deductions_title}
                      </h3>
                      <p className="md:!text-[10px] md:leading-[14px] xl:!text-[13px] xl:leading-[20px] tracking-tight hidden lg:block extra-para-vs">
                        {translations.other_deductions_info}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex pt-[1.5rem] reveal-up block lg:hidden">
                <div className="px-4">
                  <h3 className="font-semibold mb-1 text-[16px]">Premiums</h3>
                  <p className="text-[14px] leading-[22px] mb-4 pb-4 border-b border-solid border-[#C6C4C4]">
                    (Minus the premium expense charge as shown on the policy
                    schedule.)
                  </p>
                  <h3 className="font-semibold mb-1 text-[16px]">
                    Monthly deductions
                  </h3>
                  <p className="text-[14px] leading-[22px] mb-4 pb-4 border-b border-solid border-[#C6C4C4]">
                    (Including an administrative fee, cost of insurance for the
                    policy, front-eMay include an administrative fee, cost of
                    insurance for the policy, front-end load, charge per $1.000
                    of specified amount, and rider charges.nd load, if any, any
                    riders, and a charge per $1.000 of specified amount.)
                  </p>
                  <h3 className="font-semibold mb-1 text-[16px]">
                    Other deductions
                  </h3>
                  <p className="text-[14px] leading-[22px] mb-4 pb-4">
                    (Including any partial surrenders and partial surrender
                    charges.)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="Universal-types"
        className="panel universal-insurance-type py-24 lg:py-32 bg-[#0D4248]"
      >
        <div className="container">
          <div className="flex lg:flex-nowrap flex-wrap gap-8">
            <div className="lg:w-[26%] w-full md:pl-0 pl-2 reveal-up">
              <p className="text-sm text-white mb-1   ml-1 md:hidden block">
                Universal Products
              </p>
              <h2 className="text-white md:text-[30px] xl:text-[2.5rem] text-[24px] font-semibold leading-[28px] md:leading-[33px] xl:leading-[2.8rem] lg:tracking-tight mb-4 extra-title-heading">
                {translations.universal_types_title}
              </h2>
            </div>
            <div className=" lg:w-[74%]  w-full">
              <div className="flex md:flex-nowrap flex-wrap gap-8">
                <div className="md:w-[50%] w-full reveal-up reveal-delay-2">
                  <div className="bg-[#F7F6F2] py-16 px-9 rounded-xl h-full universal-type-grid">
                    <div className="flex items-center mb-4">
                      <img className="pr-6" src={UniversalType1} alt="" />
                      <h3 className="text-[1.5rem] md:text-[18px] md:leading-[22px] xl:text-[1.5rem] xl:leading-[1.8rem] font-semibold tracking-tight leading-[1.8rem] max-w-[300px] extra-title36">
                        {translations.indexed_universal_life}
                      </h3>
                    </div>
                    <p
                      className="text-[14px] leading-[22px] md:text-[10.5px] md:leading-[16.5px] xl:text-[14px] xl:leading-[22px] mb-4 pb-4 border-b border-solid border-[#C6C4C4]"
                      dangerouslySetInnerHTML={{
                        __html: translations.indexed_universal_life_desc,
                      }}
                    ></p>
                    <p className="text-[14px] leading-[22px] md:text-[10.5px] md:leading-[16.5px] xl:text-[14px] xl:leading-[22px] mb-4 pb-4 border-b border-solid border-[#C6C4C4]">
                      {translations.indexed_min_death_benefit}
                    </p>
                    <p className="text-[14px] leading-[22px] md:text-[10.5px] md:leading-[16.5px] xl:text-[14px] xl:leading-[22px] mb-4 pb-4">
                      {translations.indexed_issue_ages}
                    </p>
                    <Link
                      to="/indexed-universal-life-insurance"
                      className="
                bg-[#0D4248] hover:bg-[#0D4248] hover:text-[#ffffff]
                text-white font-bold rounded-full text-[14px] md:text-[10.5px] xl:text-[14px] px-5 text-center py-[13.5px] lg:py-[10px] xl:py-[13.5px] w-full md:w-auto extra-btn-font"
                    >
                      {translations.indexed_learn_more}
                    </Link>
                  </div>
                </div>
                <div className="md:w-[50%] w-full reveal-up reveal-delay-3">
                  <div className="bg-[#F7F6F2] py-16 px-9 rounded-xl h-full universal-type-grid">
                    <div className="flex items-center mb-4">
                      <img className="pr-6" src={UniversalType2} alt="" />
                      <h3 className="text-[1.5rem] md:text-[18px] md:leading-[22px] xl:text-[1.5rem] xl:leading-[1.8rem] font-semibold tracking-tight leading-[1.8rem] max-w-[300px] extra-title36">
                        {translations.universal_life}
                      </h3>
                    </div>
                    <p className="text-[14px] leading-[22px] md:text-[10.5px] md:leading-[16.5px] xl:text-[14px] xl:leading-[22px] mb-4 pb-4 border-b border-solid border-[#C6C4C4]">
                      {translations.universal_life_desc}
                    </p>
                    <p className="text-[14px] leading-[22px] md:text-[10.5px] md:leading-[16.5px] xl:text-[14px] xl:leading-[22px] mb-4 pb-4 border-b border-solid border-[#C6C4C4]">
                      {translations.universal_min_death_benefit}
                    </p>
                    <p className="text-[14px] leading-[22px] md:text-[10.5px] md:leading-[16.5px] xl:text-[14px] xl:leading-[22px] mb-4 pb-4 border-b border-solid border-[#C6C4C4]">
                      {translations.universal_issue_ages}
                    </p>
                    <p className="text-[14px] leading-[22px] md:text-[10.5px] md:leading-[16.5px] xl:text-[14px] xl:leading-[22px] mb-4 pb-4">
                      <span className="font-semibold">
                        {translations.universal_available_products}
                      </span>
                      <br />
                      {translations.universal_product_1}
                      <br />
                      {translations.universal_product_2}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FAQs />
      <HealthInsuranceHero />
    </div>
  );
};

export default UniversalLifeInsurance;
